/**
 * URL parameter capture for attribution tracking.
 * Reads gclid, utm_* and promo from the URL on page load,
 * persists them in sessionStorage, and provides helpers to
 * read them back at checkout / order placement.
 */

const STORAGE_KEY = 'skinnthrive_attribution';

/** Read attribution params from the current URL and persist to sessionStorage. */
export const captureUrlParams = () => {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const gclid       = params.get('gclid');
  const fbclid      = params.get('fbclid');
  const utmSource   = params.get('utm_source');
  const utmMedium   = params.get('utm_medium');
  const utmCampaign = params.get('utm_campaign');
  const utmContent  = params.get('utm_content');
  const utmTerm     = params.get('utm_term');
  const promo       = params.get('promo');

  // Only overwrite if we received at least one attribution signal
  if (gclid || fbclid || utmSource || utmMedium || utmCampaign || promo) {
    const data = {};
    if (gclid)       data.gclid       = gclid;
    if (fbclid)      data.fbclid      = fbclid;
    if (utmSource)   data.utmSource   = utmSource;
    if (utmMedium)   data.utmMedium   = utmMedium;
    if (utmCampaign) data.utmCampaign = utmCampaign;
    if (utmContent)  data.utmContent  = utmContent;
    if (utmTerm)     data.utmTerm     = utmTerm;
    if (promo)       data.promo       = promo;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }
};

/** Returns the stored attribution data (or empty object). */
export const getAttribution = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

/** Returns the stored promo code (for auto-applying at checkout). */
export const getPromoFromUrl = () => getAttribution().promo || null;

/** Clear attribution data after an order is placed. */
export const clearAttribution = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
